"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nameGenerator_1 = require("./util/nameGenerator");
exports.allRaces = nameGenerator_1.allRaces;
exports.nameByRace = nameGenerator_1.generateName;
